// extracted by mini-css-extract-plugin
module.exports = {"cls1":"TaskWorklistsPage-CssProp15_td-module--cls1--3qVHa","cls2":"TaskWorklistsPage-CssProp15_td-module--cls2--2-0Yn TaskWorklistsPage-CssProp15_td-module--cls1--3qVHa"};